// extracted by mini-css-extract-plugin
export var dividerContainer = "_7i-0";
export var line = "_7i-1";